import { Component, OnInit } from '@angular/core';
import { EmployeeEligibilityReportService } from './employeeEligibilityReport.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

@Component({
    moduleId: module.id,
    templateUrl: 'employeeEligibilityReport.html'

})
export class EmployeeEligibilityReportComponent implements OnInit {

    dataLoaded: boolean;
    //selectedYear: string;
    selectedYear: string[];
    selectedUnionStatus: string;
    //selectedControlGroup: string;
    selectedControlGroup: string[];
    selectedTypeOfHours: string;
    downloadPdfInProgress: boolean = false;
    downloadExcelInProgress: boolean = false;

    Years: Array<string>;
    UnionStatus: Array<string>;
    ControlGroups: Array<string>;
    TypeOfHours: Array<string>;

    public rows: Array<any> = [];
    public page = 1;
    public itemsPerPage = 10;
    public maxSize = 5;
    public numPages = 1;
    public length = 0;

    optionsModel: number[];
    myOptionsYear: IMultiSelectOption[];
    myOptionsCG: IMultiSelectOption[];

    mySettings: IMultiSelectSettings = {
        enableSearch: false,
        showCheckAll: true,
        showUncheckAll: true,
        checkedStyle: 'checkboxes',
        buttonClasses: 'btn btn-default btn-block',
        dynamicTitleMaxItems: 1,
        displayAllSelectedText: false
    };

    // Text configuration
    myTexts: IMultiSelectTexts = {
        checkAll: 'Select all',
        uncheckAll: 'Unselect all'
    };

    public columns: Array<any> = [
        { title: 'Controlled Group', className: 'va-m', name: 'ControlGroup' },
        // { title: 'Work Year', className: 'va-m', name: 'WorkYear' },
        { title: 'Employee Name', className: 'va-m', name: 'EmployeeName' },
        { title: 'Union Status', className: 'va-m', name: 'UnionStatus' },
        { title: 'Union Name', className: 'va-m', name: 'unionName' },
        { title: 'SSN', className: 'va-m', name: 'SSN' },
        { title: 'Most Recent Show', className: 'va-m', name: 'MostRecentShow' },
        { title: 'Most Recent Job Title', className: 'va-m', name: 'MostRecentJobTitle' },
        { title: 'Avg Weekly Hours', className: 'va-m', name: 'AverageWeeklyHours' },
        { title: 'Total Hours', className: 'va-m', name: 'TotalHours' },
        { title: 'Standard Measured Eligibility', className: 'va-m', name: 'StandardMeasuredEligibility' },
        { title: 'Benefits Effective', className: 'va-m', name: 'BenefitsEffective' },

    ];

    public config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table', 'table-striped', 'table-bordered', 'table-hover']
    };

    empDetails: Array<any> = [];
    errorMessage: string;
    constructor(private _employeeEligibilityReportService: EmployeeEligibilityReportService) { }

    ngOnInit(): void {

        this.myOptionsYear = [];
        this.myOptionsCG = [];

        this._employeeEligibilityReportService.getReportReferenceData().subscribe(data => {

            data.WorkYear.forEach(element => {
                this.myOptionsYear.push({ id: element, name: element })
            });

            data.ControlGroup.forEach(element => {
                this.myOptionsCG.push({ id: element, name: element })
            });

            this.UnionStatus = data.UnionStatus;
            this.TypeOfHours = data.TypeOfHours;

        },
            error => this.errorMessage = <any>error);

        //this.selectedYear = '-1';
        //this.selectedControlGroup = '-1';
        this.selectedUnionStatus = '-1';
        this.selectedTypeOfHours = '-1';
    }


    reset(): void {
        //this.selectedYear = '-1';
        //this.selectedControlGroup = '-1';
        this.selectedYear = [];
        this.selectedControlGroup = [];
        this.dataLoaded = false;
    }

    getFilterValues(): any {

        let tyear = this.selectedYear;
        if (tyear === undefined) {
            tyear = [];
            tyear[0] = '\'\'';
            this.selectedYear = [];
        }
        if (tyear !== undefined && tyear.length <= 0) {
            tyear[0] = '\'\'';
            this.selectedYear = [];
        }

        let cg = this.selectedControlGroup;
        if (cg === undefined) {
            cg = [];
            cg[0] = '\'\'';
            this.selectedControlGroup = [];
        }
        if (cg !== undefined && cg.length <= 0) {
            cg[0] = '\'\'';
            this.selectedControlGroup = [];
        }

        /*
        let year = this.selectedYear;
        if (year === '-1') {
            year = "''";
        }

        let cg = this.selectedControlGroup;
        if (cg === 'All' || cg === '-1' || cg === undefined) {
            cg = "''";
        }
        */
        let us = this.selectedUnionStatus;
        if (us === '' || us === '-1' || us === undefined) {
            us = "''";
        }
        let th = this.selectedTypeOfHours;
        if (th === '' || th === '-1' || th === undefined) {
            th = "''";
        }
        let filterCriteria: any = {
            selectedYear: tyear.join(':'),
            selectedControlGroup: cg.join(':'),
            selectedUnionStatus: us,
            selectedTypeOfHours: th
        };

        return filterCriteria;
    }

    employeeEligibleReportsData(): void {

        const filterCriteria = this.getFilterValues();
        this._employeeEligibilityReportService.getEmployeeEligibleReports(filterCriteria).subscribe(empdetails => {
            this.empDetails = empdetails;
            this.onChangeTable(this.config);
            this.dataLoaded = true;
        },
            error => this.errorMessage = <any>error);

    }

    Search(): void {

        this.dataLoaded = false;
        this.employeeEligibleReportsData();
    }

    downloadPdf(): void {
        this.downloadPdfInProgress = true;
        const filterCriteria = this.getFilterValues();
        this._employeeEligibilityReportService.downloadPDFReport(filterCriteria).subscribe(data => {
            this.downloadPdfInProgress = false;
        }, err => (this.downloadPdfInProgress = false));
    }

    downloadExcel(): void {
        this.downloadExcelInProgress = true;
        const filterCriteria = this.getFilterValues();
        this._employeeEligibilityReportService.downloadExcelReport(filterCriteria).subscribe(data => {
            this.downloadExcelInProgress = false;
        }, err => (this.downloadExcelInProgress = false));
    }
    public changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        const columns = this.config.sorting.columns || [];
        let columnName: string = void 0;
        let sort: string = void 0;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }
            return 0;
        });
    }

    public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        const filteredData = this.changeFilter(this.empDetails, this.config);
        const sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

    public changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;
        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) =>
                item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        const tempArray: Array<any> = [];
        filteredData.forEach((item: any) => {
            let flag = false;
            this.columns.forEach((column: any) => {
                if (item[column.name] == null) {
                    item[column.name] = '';
                }
            });
            this.columns.forEach((column: any) => {
                if (item[column.name].toLowerCase().match(new RegExp(this.config.filtering.filterString, 'i'))) {
                    flag = true;
                }
                else if (item[column.name].toUpperCase().match(new RegExp(this.config.filtering.filterString, 'i'))) {
                    flag = true;
                }
            });
            if (flag) {
                tempArray.push(item);
            }
        });
        filteredData = tempArray;

        return filteredData;
    }

    public changePage(page: any, data: Array<any> = this.empDetails): Array<any> {
        const start = (page.page - 1) * page.itemsPerPage;
        const end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
        return data.slice(start, end);
    }

}



// WEBPACK FOOTER //
// ./src/app/EmployeeEligibilityReport/employeeEligibilityReport.component.ts